import { EmptyArray } from "../domain/empty/model";
import { ServiceRepositoryImplementation } from '../infrastructure/service-repository-implementation';
import { Service } from '../domain/Service/model';
 // Assuming this model exists

const repo = new ServiceRepositoryImplementation();

// Caches for the new model
const serviceCache = new Map<number, Service>();
const servicesListCache = new Map<string, any>();

async function createService(data: Partial<Service>) {
  try {
    const result = await repo.createService(data).toPromise();
    // Invalidate caches after a creation
    serviceCache.clear();
    servicesListCache.clear();
    return result;
  } catch (error) {
    console.error(error);
    throw error; // Propagate the error for the UI to handle
  }
}

async function getService(id: number) {
  try {
    if (serviceCache.has(id)) {
      console.log(`Returning service with ID ${id} from cache`);
      return serviceCache.get(id);
    }
    const result = await repo.getService(id).toPromise();
    if (!result) return EmptyArray;
    const data = result.data; // Assuming that the API returns { data: ... }
    if (!data) return EmptyArray; // Or an empty object if it's a single element
    serviceCache.set(id, data);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function getServices(page: number, limit: number, query = "") {
  try {
    const cacheKey = `services-${page}-${limit}-${query}`;
    if (servicesListCache.has(cacheKey)) {
      console.log(`Returning services for page ${page} from cache`);
      return servicesListCache.get(cacheKey);
    }
    const result = await repo.getServices(page, limit, query).toPromise();
    if (!result || !result.data || result.data.length === 0) {
      return { data: EmptyArray, total: 0, page: page, page_size: limit };
    }
    servicesListCache.set(cacheKey, result);
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function updateService(id: number, data: Partial<Service>) {
  try {
    const result = await repo.updateService(id, data).toPromise();
    // Invalidate caches after an update
    serviceCache.clear();
    servicesListCache.clear();
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function deleteService(id: number) {
  try {
    await repo.deleteService(id).toPromise();
    // Invalidate caches after a deletion
    serviceCache.clear();
    servicesListCache.clear();
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function createServiceSale(payload: unknown) {
  const result = await repo.createServiceSale(payload).toPromise();
  serviceCache.clear();
  servicesListCache.clear();
  return result?.data ?? result;
}

async function getServiceInvoices(page = 1, limit = 10, status?: string, date_from?: string, date_to?: string) {
  const result: any = await repo.getServiceInvoices(page, limit, status, date_from, date_to).toPromise();
  const resData = result?.data ?? result;
  if (!resData || !Array.isArray(resData.data)) {
    return { data: EmptyArray, total: 0, page, page_size: limit };
  }
  return resData;
}

async function getServiceConflicts(page = 1, limit = 10) {
  const result: any = await repo.getServiceConflicts(page, limit).toPromise();
  const resData = result?.data ?? result;
  if (!resData || !Array.isArray(resData.data)) {
    return { data: EmptyArray, total: 0, page, page_size: limit };
  }
  return resData;
}

async function resolveServiceConflict(bill_id: number, force_generate = false) {
  const result = await repo.resolveServiceConflict(bill_id, force_generate).toPromise();
  return result?.data ?? result;
}

export {
  createService,
  getService,
  getServices,
  updateService,
  deleteService,
  createServiceSale,
  getServiceInvoices,
  getServiceConflicts,
  resolveServiceConflict,
};
